import { Stack, Typography } from "@mui/material";
import { SignInPrompt } from "Components/AnonymousCustomer/Payment/PaymentDetail/SignInPrompt";
import { AnonymousTransactionIdEntryForm } from "Components/AnonymousCustomer/Payment/PaymentDetail/AnonymousTransactionIdEntryForm";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Customer.Pay.ManualEntry;

// Shown when /pay is opened without a transaction ID — the visitor can type one
// instead of being sent away to sign in. Nothing failed here, so the message is
// a plain prompt rather than error text.
export const MissingTransactionIdContent = () => {
  const { t } = useResource();

  return (
    <Stack gap={3} height="100%">
      <Stack
        flexGrow={1}
        px={3}
        py={4}
        justifyContent="center"
        alignItems="center"
      >
        <AnonymousTransactionIdEntryForm
          message={
            <Typography
              fontSize="0.875rem"
              textAlign="center"
              color="text.secondary"
            >
              {t(RESOURCES.TransactionIdNotProvided)}
            </Typography>
          }
        />
      </Stack>
      <SignInPrompt returnUrl={appUrl("customer-payment-pay")} />
    </Stack>
  );
};
